import TitleSectionTemplateStore from "../store/title-section-template-store";
import {TitleSection, TitleSectionTemplate} from "../../entity/model/title-section-template";
import {ManageMode} from "../../entity/enums/manage-mode";
import {TitleSectionTemplateDto} from "../../entity/dto/title-section-template-dto";
import {RequestBody} from "../../entity/core/request-body";
import {toast} from "react-toastify";

export default class TitleSectionTemplateService {
    titleSectionTemplateStore: TitleSectionTemplateStore;

    constructor(titleSectionTemplateStore: TitleSectionTemplateStore) {
        this.titleSectionTemplateStore = titleSectionTemplateStore;
    }

    getTitleSectionTemplates = async (organizationId: string, reload: boolean): Promise<TitleSectionTemplate[]> => {
        return this.titleSectionTemplateStore.cache && !reload
            ? this.titleSectionTemplateStore.titleSectionTemplates
            : this.titleSectionTemplateStore.getTitleSectionTemplates(organizationId);
    }

    createTitleSectionTemplate = async (organizationId: string, templatePayload: TitleSectionTemplateDto): Promise<void> => {
        const requestBody: RequestBody = { body: templatePayload };
        const response = await this.titleSectionTemplateStore.createTitleSectionTemplate(organizationId, requestBody);

        if (!response)
            toast.success('Title section template created successfully !!');
        else
            toast.error(response);
    }

    updateTitleSectionTemplate = async (organizationId: string, titleSectionTemplateId: string, templatePayload: TitleSectionTemplateDto): Promise<void> => {
        const requestBody: RequestBody = { body: templatePayload };
        const response = await this.titleSectionTemplateStore.updateTitleSectionTemplate(organizationId, titleSectionTemplateId, requestBody);

        if (!response)
            toast.success('Title section template updated successfully !!');
        else
            toast.error(response);
    }

    deleteTitleSectionTemplate = async (organizationId: string, titleSectionTemplateId: string): Promise<void> => {
        const response = await this.titleSectionTemplateStore.deleteTitleSectionTemplate(organizationId, titleSectionTemplateId);

        if (!response)
            toast.success('Title section template deleted successfully !!');
        else
            toast.error(response);
    }

    filterTemplates = (input: string): TitleSectionTemplate[] => {
        return this.titleSectionTemplateStore.titleSectionTemplates.filter((template: TitleSectionTemplate) => {
            const matchesName = template.name.trim().toLowerCase().startsWith(input);
            const matchesDescription = template.description.trim().toLowerCase().startsWith(input);
            return matchesName || matchesDescription;
        });
    }

    getTitleSectionTemplateDto = (mode: ManageMode, titleSectionTemplate?: TitleSectionTemplate): TitleSectionTemplateDto => {

        return {
            createdByUserID: mode === ManageMode.CREATE ? '' : titleSectionTemplate?.createdByUserID ?? '',
            name: mode === ManageMode.CREATE ? '' : titleSectionTemplate?.name ?? '',
            description:  mode === ManageMode.CREATE ? '' : titleSectionTemplate?.description ?? '',
            sections: mode === ManageMode.CREATE ? [] : titleSectionTemplate?.sections.map((section: TitleSection) => section.name) ?? []
        }
    }

    getCache = (): boolean => {
        return this.titleSectionTemplateStore.cache;
    }
}